module.exports = "<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"flow\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"admin-copy-2\" transform=\"translate(-412.000000, -851.000000)\"><g id=\"Oval-Copy-3\" fill=\"#7695A5\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"419\" cy=\"858\" r=\"6\"></circle></g></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false&removeTags=true!./src/images/svg/status-icons/away-with-notifications.svg
// module id = NrfI
// module chunks = 89